import { render, staticRenderFns } from "./DetailTipsPop.vue?vue&type=template&id=752c0c28&scoped=true&"
import script from "./DetailTipsPop.vue?vue&type=script&lang=js&"
export * from "./DetailTipsPop.vue?vue&type=script&lang=js&"
import style0 from "./DetailTipsPop.vue?vue&type=style&index=0&id=752c0c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c0c28",
  null
  
)

export default component.exports